const auth = (state = {}) => {
  return state;
};
export default auth;